import { create, type StateCreator } from "zustand";
import { devtools, persist, type PersistOptions } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

type WithMiddlewares<T> = StateCreator<T, [["zustand/immer", never]], [], T>;

export const createStore = <T extends object>(
  initializer: WithMiddlewares<T>,
  persistOptions: PersistOptions<T>
) => {
  return create<T>()(devtools(immer(persist(initializer, persistOptions))));
};
